import React from "react";
import './App.css';
import Weather from './Weather';

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Toronto" />
      <footer>
        This project was coded by Krystal Mulhall and is{""}      
  <a href="https://github.com/KrystalMulhall/react-weather-app" target="_blank" rel='noreferrer'> <em>open-sourced on GitHub</em></a>
      </footer>
      </div>
      </div>
  );
}

export default App;
